import { styled } from '@mui/material/styles';
import { SearchInput as RaSearchInput, SearchInputProps } from 'react-admin';

const StyledSearchInput = styled(RaSearchInput, { slot: 'root' })(() => ({}));

function SearchInput(props: SearchInputProps): JSX.Element {
  return <StyledSearchInput {...props} />;
}
export { SearchInput };
export type { SearchInputProps };
